module.exports = __webpack_public_path__ + "img/user2.94cc871d.png";